import React from 'react'
import { Row, Col, FormGroup, Label, Input, Switch } from 'twyne-new.ui';

const IfficientForm = ({data, onChange, disabled}) => {
  return (
    <Row>
      <Col size="3">
        <FormGroup>
          <Label>Pub ID</Label>
          <Input type="text" value={data.pubid || ''}
            onChange={(e) => onChange('pubid', e.target.value)} disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size="3">
        <FormGroup>
          <Label>Source ID</Label>
          <Input type="text" value={data.srcid || ''}
            onChange={(e) => onChange('srcid', e.target.value)} disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size="3">
        <FormGroup>
          <Label>Suppress Redirect</Label>
          <Switch
            onChange={(e) => onChange('suppressredirect', e.target.checked)}
            checked={data.suppressredirect || false}
            disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size="3">
        <FormGroup>
          <Label>Test Mode</Label>
          <Switch
            onChange={(e) => onChange('istest', e.target.checked)}
            checked={data.istest || false}
            disabled={disabled}
          />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default IfficientForm;